import React from 'react';
import Loader from 'react-loader-spinner';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';

const LoaderIcon = props => {
  return <Loader type="Triangle" visible={true} color="#b96ae7" height={75} width={75} style={{ marginTop: '20px', ...props.style }} />;
};

export default LoaderIcon;
